<!-- components/EventOverviewCard.vue -->
<template>
	<a :href="event.link" class="event-item" target="_blank" rel="noopener noreferrer">
		<div class="image-container">
			<picture>
				<source v-if="event.imageWebp" :srcset="event.imageWebp" type="image/webp" />
				<source :srcset="event.image" />
				<img loading="lazy" :src="event.image" :alt="event.imageAlt" />
			</picture>
		</div>
		<div class="event-item-content">
			<h3>{{ event.header }}</h3>
			<p>{{ event.tagline }}</p>
			<p>{{ event.dates }}</p>
			<p>{{ event.venue }}</p>
			<p>{{ event.ticketprice }}</p>
		</div>
		<div class="button-container">
			<span>
				{{ $t('readMore') }}
				<font-awesome-icon icon="fa-light fa-arrow-right-long" size="1x" />
				<div class="button button-cta reserve-now">
					{{ event.button }}
				</div>
			</span>
		</div>
	</a>
</template>

<script setup>
defineProps({
	event: { type: Object, required: true },
});
</script>

<style scoped>
.event-item {
	position: relative;
	display: flex;
	flex-flow: column;
	padding: 0;
	width: 23.5%;
	background-color: var(--header-color);
	border-bottom: 1px solid #fff;

	.image-container {
		width: 100%;
		aspect-ratio: 990 / 1400;
		position: relative;
		overflow: hidden;
		transition: all 0.3s ease-in-out;

		img {
			width: 100%;
			object-fit: cover;
			transition: all 0.3s ease-in-out;
			padding-bottom: 20px;
		}

		&::after {
			content: '';
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			transition: background 0.3s ease-in-out;
			pointer-events: none;
		}
	}

	.event-item-content {
		position: relative;
		display: flex;
		flex: 1;
		flex-flow: column;
		justify-content: space-between;
		gap: 5px;
		padding: 20px;
		z-index: 3;
		text-align: left;
		color: var(--header-color);

		h3 {
			line-height: unset;
			margin-bottom: 20px;
			flex: 1;
		}

		h3,
		div {
			color: #fff;
			transition: color 0.3s ease;
		}

		p {
			font-size: 14px;
			color: #fff;
			margin: 0;
			line-height: 1.4;
		}

		p:first-of-type {
			height: 40px;
			margin-bottom: 20px;
		}

		div {
			color: #fff;
			transition: color 0.3s ease;

			p {
				font-size: 14px;
				font-weight: 500;
				color: var(--body-color);
				margin: 0;
			}
		}

		span {
			color: #fff;
			transition: color 0.3s ease;
			text-transform: uppercase;
			font-size: var(--button-font-size);
			font-weight: 500;
			display: flex;
			justify-content: space-between;
			align-items: center;
			z-index: 999;
			margin: 0;
		}
	}

	.button-container {
		z-index: 3;
		position: relative;
		inset: auto 0 0;

		.button {
			margin: 0;
		}

		span {
			padding-left: 20px;
			border-top: 1px solid #fff;
			display: flex;
			justify-content: space-between;
			align-items: center;
			text-transform: uppercase;
			font-size: 14px;
			font-weight: 500;

			a {
				margin: 0;
				border-bottom: none;

				&:hover {
					background: var(--header-color);
				}
			}
		}
	}

	@media (min-width: 680px) {
		&:hover {
			background: #fff;
			background-color: #c0924a26;
			transition: all 0.3s ease-in-out;

			img {
				transform: scale(1.02);
			}

			.event-item-content {
				color: white;

				h3,
				span,
				p,
				div {
					color: white;
				}
			}

			.button-container {
				span {
					border-top: 1px solid #fff !important;
				}
			}
		}
	}
}

@media (max-width: 1370px) {
	.event-item {
		margin: 0 0 2%;
		width: 49% !important;
	}
}

@media (max-width: 680px) {
	.event-item {
		margin: 10px auto;
		width: 100% !important;
	}
}
</style>
